// Corsac product form: used by the product page, the quick look popup and the homepage featured product.
// Skeleton follows the live theme: title, type, rating, price, colour/style, size + size guide, stock, quantity + add,
// buy now, delivery / pickup / sizing help, description, fabric & details, shipping & returns, share.
(function () {
  const CX = window.CX;
  const { $, $$, esc, icon, roll } = CX;
  const R = CX.routes;
  const T = CX.productTexts;

  /* ---------- Expected delivery: today + 1–3 days, written as a date range ---------- */
  const deliveryRange = () => {
    const d = T.delivery || { min: 1, max: 3 };
    const min = Math.max(0, Number(d.min) || 0);
    const max = Math.max(min, Number(d.max) || 0);
    const at = (n) => {
      const x = new Date(); x.setHours(12, 0, 0, 0);
      for (let left = n; left > 0;) { x.setDate(x.getDate() + 1); if (!(d.skipSunday && x.getDay() === 0)) left--; }
      return x;
    };
    const a = at(min);
    const b = at(max);
    const m = (x) => x.toLocaleDateString('en-GB', { month: 'long' });
    const same = a.getTime() === b.getTime();
    const range = same ? `${a.getDate()} ${m(a)} ${a.getFullYear()}`
      : a.getFullYear() !== b.getFullYear() ? `${a.getDate()} ${m(a)} ${a.getFullYear()} – ${b.getDate()} ${m(b)} ${b.getFullYear()}`
      : a.getMonth() !== b.getMonth() ? `${a.getDate()} ${m(a)} – ${b.getDate()} ${m(b)} ${b.getFullYear()}`
      : `${a.getDate()} – ${b.getDate()} ${m(a)} ${a.getFullYear()}`;
    return { range, days: same ? `${min} ${min === 1 ? 'day' : 'days'}` : `${min}–${max} days` };
  };

  const acc = (title, body, open) => `<details class="cx-pacc"${open ? ' open' : ''}><summary>${title}<span class="cx-plus" aria-hidden="true"></span></summary><div class="cx-pacc__body cx-rich">${body}</div></details>`;

  /* ---------- The form ---------- */
  CX.pform = (p, full) => {
    const H = full ? 'h1' : 'h2';
    const size = CX.firstSize(p);
    const label = CX.variantLabel(p);
    const current = (p.variants || []).find(([id]) => id === p.id);
    const swatches = (p.variants || []).filter(([id]) => CX.byId(id)).map(([id, name]) => {
      const v = CX.byId(id);
      const on = id === p.id;
      const attrs = on ? 'aria-current="true"' : full ? `href="${R.product(id)}"` : `data-cx-quick="${esc(id)}"`;
      const tag = on || full ? 'a' : 'button';
      return `<${tag} class="cx-swatch${on ? ' is-on' : ''}" ${attrs} title="${esc(name)}" aria-label="${label}: ${esc(name)}">${CX.pic(v.gallery[0], { w: 160, sizes: '48px' })}</${tag}>`;
    }).join('');
    const del = deliveryRange();
    // The compact buying area (product page setting) applies to the full product page form only.
    const compact = full && T.buyLayout === 'compact';
    return `<div class="cx-pform${compact ? ' cx-pform--compact' : ''}" data-cx-pform="${esc(p.id)}">
      <${H} class="cx-pform__name">${esc(p.name)}</${H}>
      ${p.type ? `<p class="cx-pform__type">${esc(p.type)}</p>` : ''}
      ${compact ? `<div class="cx-pform__priceline"><p class="cx-pform__price">${CX.price(p)}${CX.badge(p) && p.inStock ? `<span class="cx-badge cx-badge--solid">${CX.badge(p)}</span>` : ''}</p>${p.reviews > 0 ? `<a class="cx-pform__stars" href="#reviews">${CX.stars(p)}</a>` : ''}</div>` : `
      ${p.reviews > 0 ? `<a class="cx-pform__stars" href="${full ? '#reviews' : R.product(p.id) + '#reviews'}">${CX.stars(p)}</a>` : ''}
      <p class="cx-pform__price">${CX.price(p)}${CX.badge(p) && p.inStock ? `<span class="cx-badge cx-badge--solid">${CX.badge(p)}</span>` : ''}</p>`}
      ${full ? '' : `<p class="cx-pform__excerpt">${esc(CX.excerpt(p))}</p>`}
      ${swatches ? `<div class="cx-pform__group"><p class="cx-pform__label"><b>${label}:</b> ${esc(current ? current[1] : '')}</p><div class="cx-swatches">${swatches}</div></div>` : ''}
      ${p.sizes.length ? `<div class="cx-pform__group">
        <div class="cx-pform__row"><p class="cx-pform__label"><b>Size:</b> <span data-cx-size-label>${esc(size)}</span></p>
        ${T.sizeGuide ? `<button type="button" class="cx-pform__guide" data-cx-guide>${icon('ruler', 'cx-icon--sm')}${esc(T.sizeGuide)}</button>` : ''}</div>
        <div class="cx-sizes">${p.sizes.map((s) => `<button type="button" class="cx-size${s === size ? ' is-on' : ''}" data-size="${esc(s)}"${CX.isSold(p, s) ? ` disabled title="Sold out" aria-label="${esc(s)}, sold out"` : ''}>${esc(s)}</button>`).join('')}</div>
      </div>` : ''}
      ${compact ? `
      <div class="cx-pform__stockline">
        <p class="cx-stock${p.inStock ? '' : ' is-out'}"><i></i>${p.inStock ? 'In stock' : 'Out of stock'}</p>
        ${p.inStock ? `<div class="cx-qty"><button type="button" data-cx-step="-1" aria-label="Decrease quantity">${icon('minus', 'cx-icon--sm')}</button><output data-cx-qtyval>1</output><button type="button" data-cx-step="1" aria-label="Increase quantity">${icon('plus', 'cx-icon--sm')}</button></div>` : ''}
      </div>
      <div class="cx-pform__pair${p.inStock && T.buyNow ? '' : ' cx-pform__pair--one'}">
        <button type="button" class="cx-btn" data-cx-addform${p.inStock ? '' : ' disabled'}>${roll(p.inStock ? 'Add to cart' : 'Sold out')}</button>
        ${p.inStock && T.buyNow ? `<button type="button" class="cx-btn cx-btn--line" data-cx-buynow>${roll(T.buyNow)}</button>` : ''}
      </div>
      ${p.inStock && (!T.delivery || T.delivery.show !== false) ? `<p class="cx-pform__promise">${icon('van', 'cx-icon--sm')}<span>Order now, delivered <b>${del.range.replace(/ \d{4}$/, '')}</b>${T.cod !== false ? ' · Cash on delivery' : ''}${T.delivery && T.delivery.note ? ` · ${esc(T.delivery.note)}` : ''}</span></p>` : ''}
      <p class="cx-pform__links">
        ${!T.pickup || T.pickup.show !== false ? `<a href="${CX.site.maps}" target="_blank" rel="noopener">${icon('pin', 'cx-icon--sm')}${esc((T.pickup && T.pickup.title) || 'Pickup at store')}</a>` : ''}
        ${T.showHelp !== false ? `<a href="${CX.site.whatsapp}" target="_blank" rel="noopener">${icon('whatsapp', 'cx-icon--sm')}${esc(T.help || 'Need help with sizing?')}</a>` : ''}
      </p>
      ${(T.trust || []).length ? `<ul class="cx-pform__trust">${T.trust.map((t) => `<li>${icon('check', 'cx-icon--sm')}${esc(t)}</li>`).join('')}</ul>` : ''}` : `
      <p class="cx-stock${p.inStock ? '' : ' is-out'}"><i></i>${p.inStock ? 'In stock' : 'Out of stock'}</p>
      <div class="cx-pform__buy">
        <div class="cx-qty cx-qty--lg"><button type="button" data-cx-step="-1" aria-label="Decrease quantity">${icon('minus', 'cx-icon--sm')}</button><output data-cx-qtyval>1</output><button type="button" data-cx-step="1" aria-label="Increase quantity">${icon('plus', 'cx-icon--sm')}</button></div>
        <button type="button" class="cx-btn" data-cx-addform${p.inStock ? '' : ' disabled'}>${roll(p.inStock ? 'Add to cart' : 'Sold out')}</button>
      </div>
      ${full && p.inStock && T.buyNow ? `<button type="button" class="cx-btn cx-btn--line cx-btn--block" data-cx-buynow>${roll(T.buyNow)}</button>` : ''}`}
      ${full ? `${compact ? '' : `
      <div class="cx-perks">
        ${p.inStock && (!T.delivery || T.delivery.show !== false) ? `<div class="cx-perk">${icon('van')}<span><b>${esc((T.delivery && T.delivery.title) || 'Expected delivery')}</b> <em>· ${del.days}</em><strong>${del.range}</strong>${T.delivery && T.delivery.note ? `<em>${esc(T.delivery.note)}</em>` : ''}</span></div>` : ''}
        ${!T.pickup || T.pickup.show !== false ? `<a class="cx-perk" href="${CX.site.maps}" target="_blank" rel="noopener">${icon('pin')}<span><b>${esc((T.pickup && T.pickup.title) || 'Pickup at store')}</b><em>${esc((T.pickup && T.pickup.text) || CX.site.address)}</em></span>${icon('chev', 'cx-icon--sm')}</a>` : ''}
        ${T.showHelp !== false ? `<a class="cx-perk" href="${CX.site.whatsapp}" target="_blank" rel="noopener">${icon('shop')}<span><b>${esc(T.help || 'Need help with sizing?')}</b><em>${esc(String(T.helpText || '').replace('[phone]', CX.site.phone))}</em></span>${icon('chev', 'cx-icon--sm')}</a>` : ''}
      </div>`}
      <div class="cx-paccs">
        ${acc('Description', p.desc || '<p>Details coming soon.</p>', true)}
        ${p.details && p.details.length ? acc('Fabric &amp; details', `<ul>${p.details.map(([k, v]) => `<li><b>${esc(k)}:</b> ${esc(v)}</li>`).join('')}</ul>`) : ''}
        ${T.returns ? acc(esc(T.returnsTitle || 'Shipping & returns'), `${T.returns}${T.returnsLink ? `<p><a class="cx-textlink is-current" href="${R.returns}">${esc(T.returnsLink)}</a></p>` : ''}`) : ''}
      </div>
      ${T.showShare !== false ? `<button type="button" class="cx-pform__share" data-cx-share>${icon('share', 'cx-icon--sm')}<span>${esc(T.share || 'Share this product')}</span></button>` : ''}`
      : `<a class="cx-link cx-pform__more" href="${R.product(p.id)}">View full details ${icon('right')}</a>`}
    </div>`;
  };

  /* ---------- Behaviour, delegated so it works for every form on the page ---------- */
  const formOf = (el) => el.closest('[data-cx-pform]');
  CX.formSize = (form) => { const on = $('.cx-size.is-on', form); return on ? on.dataset.size : ''; };
  CX.pickSize = (form, size) => {
    $$('.cx-size', form).forEach((b) => b.classList.toggle('is-on', b.dataset.size === size));
    const l = $('[data-cx-size-label]', form);
    if (l) l.textContent = size;
    form.dispatchEvent(new CustomEvent('cx:size', { bubbles: true, detail: size }));
  };
  document.addEventListener('click', (e) => {
    const form = formOf(e.target);
    if (!form) return;
    const p = CX.byId(form.dataset.cxPform);
    const size = e.target.closest('.cx-size');
    if (size && !size.disabled) CX.pickSize(form, size.dataset.size);
    const step = e.target.closest('[data-cx-step]');
    if (step) {
      const out = $('[data-cx-qtyval]', form);
      out.textContent = Math.max(1, Math.min(10, Number(out.textContent) + Number(step.dataset.cxStep)));
    }
    if (e.target.closest('[data-cx-guide]')) CX.sizeGuide(p, form);
    const add = e.target.closest('[data-cx-addform], [data-cx-buynow]');
    if (add && p.inStock) {
      const qty = Number($('[data-cx-qtyval]', form).textContent) || 1;
      add.classList.add('is-busy');
      CX.cart.add(p.id, CX.formSize(form), qty).then(() => {
        add.classList.remove('is-busy');
        if (add.hasAttribute('data-cx-buynow') && !CX.cartError) { CX.cart.checkout(); return; }
        if (CX.closeModal) CX.closeModal();
        CX.open('cart');
      });
    }
    if (e.target.closest('[data-cx-share]')) {
      const url = new URL(R.product(p.id), location.href).href;
      const label = $('[data-cx-share] span', form);
      if (navigator.share) navigator.share({ title: p.name, url }).catch(() => {});
      else if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => { label.textContent = 'Link copied'; setTimeout(() => { label.textContent = T.share; }, 2000); });
    }
  });

  /* ---------- Modal (quick look, size guide) ---------- */
  let modal = null;
  let back = null;
  const ensure = () => {
    if (modal) return modal;
    document.body.insertAdjacentHTML('beforeend', `
      <div class="cx-modal" data-cx-modal role="dialog" aria-modal="true" aria-hidden="true">
        <div class="cx-modal__scrim" data-cx-modal-close></div>
        <div class="cx-modal__panel" data-cx-modal-panel>
          <button class="cx-modal__x" data-cx-modal-close aria-label="Close">${icon('close', 'cx-icon--sm')}</button>
          <div class="cx-modal__body" data-cx-modal-body data-lenis-prevent></div>
        </div>
      </div>`);
    modal = $('[data-cx-modal]');
    modal.addEventListener('click', (e) => { if (e.target.closest('[data-cx-modal-close]')) CX.closeModal(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal.classList.contains('is-open')) CX.closeModal(); });
    return modal;
  };
  const openModal = (kind, html, label) => {
    const m = ensure();
    back = back || document.activeElement;
    m.dataset.kind = kind;
    m.setAttribute('aria-label', label);
    delete $('[data-cx-modal-body]', m).dataset.static;
    $('[data-cx-modal-body]', m).innerHTML = html;
    // A just-created modal needs one layout pass first, or it appears without its opening transition.
    void m.offsetWidth;
    m.classList.add('is-open');
    m.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cx-locked');
    if (CX.lenis) CX.lenis.stop();
    setTimeout(() => $('.cx-modal__x', m).focus({ preventScroll: true }), 60);
  };
  let returnTo = null;
  CX.closeModal = () => {
    if (!modal || !modal.classList.contains('is-open')) return;
    // A size guide opened from a quick look goes back to that quick look, with the chosen size.
    if (returnTo) {
      const { id, size } = returnTo;
      returnTo = null;
      CX.quickView(id);
      const f = $('[data-cx-pform]', modal);
      if (f && size) CX.pickSize(f, size);
      return;
    }
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.cx-sheet.is-open, .cx-search.is-open')) {
      document.body.classList.remove('cx-locked');
      if (CX.lenis) CX.lenis.start();
    }
    if (back && back.focus) back.focus({ preventScroll: true });
    back = null;
  };

  /* ---------- Quick look: photos + the short form ---------- */
  CX.quickView = (id) => {
    const p = CX.byId(id);
    if (!p) { CX.loadCatalogue().then(() => { if (CX.byId(id)) CX.quickView(id); }); return; }
    openModal('quick', `
      <div class="cx-ql">
        <div class="cx-ql__media">
          <div class="cx-ql__track cx-noscroll" data-cx-ql-track>${p.gallery.map((u, i) => `<div>${CX.pic(u, { alt: `${p.name}${p.gallery.length > 1 ? `, photo ${i + 1}` : ''}`, sizes: '(min-width: 768px) 420px, 100vw', lazy: i > 0 })}</div>`).join('')}</div>
          ${p.gallery.length > 1 ? `<div class="cx-ql__dots" data-cx-ql-dots>${p.gallery.map((_, i) => `<button aria-label="Photo ${i + 1}"${i ? '' : ' class="is-on"'}></button>`).join('')}</div>` : ''}
        </div>
        <div class="cx-ql__info">${CX.pform(p, false)}</div>
      </div>`, `Quick look: ${p.name}`);
    const track = $('[data-cx-ql-track]', modal);
    const dots = $$('[data-cx-ql-dots] button', modal);
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    }, { passive: true });
    dots.forEach((d, i) => d.addEventListener('click', () => track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' })));
  };
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-cx-quick]');
    if (!q) return;
    e.preventDefault();
    CX.quickView(q.dataset.cxQuick);
  });

  /* ---------- Size guide: the measurement chart, the chosen size's column highlighted ---------- */
  const toCm = (v) => String(v).replace(/\d+(\.\d+)?/g, (n) => String(Math.round(Number(n) * 2.54 * 2) / 2));
  CX.sizeGuide = (p, form) => {
    const chart = p.sizeChart;
    const sizes = chart ? chart.sizes : p.sizes;
    const g = { tab: chart || !p.measure ? 'chart' : 'measure', unit: 'in', size: sizes.includes(CX.formSize(form)) ? CX.formSize(form) : CX.firstSize(p) };
    const draw = () => {
      const col = sizes.indexOf(g.size);
      const ok = p.sizes.includes(g.size) && !CX.isSold(p, g.size);
      const val = (v) => (/\d/.test(v) ? `${g.unit === 'cm' ? toCm(v) : v}<small>${g.unit}</small>` : esc(v));
      return `<div class="cx-guide">
        <div class="cx-guide__head"><div><h2>Size guide</h2>${chart && chart.title ? `<p>${esc(chart.title)}</p>` : ''}</div>
          ${p.measure && g.tab === 'measure' ? '' : chart ? `<div class="cx-seg" role="group" aria-label="Units"><button data-unit="in" aria-pressed="${g.unit === 'in'}">In</button><button data-unit="cm" aria-pressed="${g.unit === 'cm'}">Cm</button></div>` : ''}</div>
        ${p.measure && chart ? `<div class="cx-seg cx-guide__tabs" role="group" aria-label="Size guide view"><button data-tab="chart" aria-pressed="${g.tab === 'chart'}">Size chart</button><button data-tab="measure" aria-pressed="${g.tab === 'measure'}">How to measure</button></div>` : ''}
        ${p.measure && g.tab === 'measure' ? `<a class="cx-guide__img" href="${CX.asset(`measure-${p.measure}.jpg`)}" target="_blank" rel="noopener"><img src="${CX.asset(`measure-${p.measure}.jpg`)}" alt="How to measure: ${esc(p.measure === 'tshirt' ? 't-shirt' : p.measure)}" width="1080" height="1080" decoding="async"></a>
        <p class="cx-guide__note">Lay the garment flat and compare with the chart. Tap the image to enlarge.</p>`
        : chart ? `<div class="cx-guide__table cx-noscroll"><table>
          <thead><tr><th scope="col">Size</th>${sizes.map((s, i) => `<th scope="col"${i === col ? ' class="is-on"' : ''}><button data-gsize="${esc(s)}" aria-pressed="${i === col}">${esc(s)}</button></th>`).join('')}</tr></thead>
          <tbody>${chart.rows.map(([k, vals]) => `<tr><th scope="row">${esc(k)}</th>${vals.map((v, i) => `<td${i === col ? ' class="is-on"' : ''} data-gsize="${esc(sizes[i])}">${val(v)}</td>`).join('')}</tr>`).join('')}</tbody>
        </table></div>
        <p class="cx-guide__note">${g.unit === 'in' ? 'Garment measurements in inches. Tap a size to select it.' : 'Converted from inches, rounded to the nearest 0.5 cm. Tap a size to select it.'}</p>`
        : `<div class="cx-guide__none"><b>Measurements for this piece aren't listed yet</b><p>Message us on WhatsApp (${CX.site.phone}) and we'll help you choose the right size.</p></div>
        <div class="cx-sizes mt-4">${sizes.map((s) => `<button class="cx-size${s === g.size ? ' is-on' : ''}" data-gsize="${esc(s)}">${esc(s)}</button>`).join('')}</div>`}
        <div class="cx-guide__actions">
          <button class="cx-btn" data-gpick${ok ? '' : ' disabled'}>${roll(ok ? `Select size ${g.size}` : `${g.size} not available`)}</button>
        </div>
      </div>`;
    };
    const fromQuick = modal && modal.classList.contains('is-open') && modal.dataset.kind === 'quick';
    openModal('guide', draw(), 'Size guide');
    delete $('[data-cx-modal-body]', modal).dataset.static;
    returnTo = fromQuick ? { id: p.id, size: CX.formSize(form) } : null;
    const body = $('[data-cx-modal-body]', modal);
    const onClick = (e) => {
      const u = e.target.closest('[data-unit]');
      const s = e.target.closest('[data-gsize]');
      const t = e.target.closest('[data-tab]');
      if (t) g.tab = t.dataset.tab;
      if (u) g.unit = u.dataset.unit;
      if (s) g.size = s.dataset.gsize;
      // Redraws after the first one don't replay the popup's entrance animation.
      if (u || s || t) { body.dataset.static = '1'; body.innerHTML = draw(); }
      if (e.target.closest('[data-gpick]')) {
        if (returnTo) returnTo.size = g.size;
        else CX.pickSize(form, g.size);
        CX.closeModal();
      }
    };
    body.onclick = onClick;
  };
})();
